import { useDispatch, useSelector } from 'react-redux';
export const useAcceptedGrantsDispatch = () => useDispatch();
export const useAcceptedGrantsSelector = useSelector;
